const LOGISTICS_ROUTE = [
  {
    path: 'logistics/custom-declaration',
    name: 'logisticsCustomDeclaration',
    component: () => import('@/views/logistics/custom-declaration/index'),
    meta: {
      title: '报关单管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'logistics/invoice-management',
    name: 'logisticsInvoiceManagement',
    component: () => import('@/views/logistics/invoice-management/index'),
    meta: {
      title: '发货单管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'logistics/first-trip-order-management',
    name: 'logisticsFirstTripOrderManagement',
    component: () => import('@/views/logistics/first-trip-order-management/index'),
    meta: {
      title: '头程总单管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'logistics/first-trip-order-management/detail',
    name: 'logisticsFirstTripOrderManagementDetail',
    component: () => import('@/views/logistics/first-trip-order-management/detail'),
    meta: {
      title: '头程总单管理详情',
      icon: '',
      keepAlive: false,
    },
  },
]

export default LOGISTICS_ROUTE
